import { ShieldAlert } from "lucide-react";

const STATUS_STYLES = {
  missing: "bg-[#FEF3C7] text-[#92400E]",
  found_alive: "bg-[#D1FAE5] text-[#065F46]",
  reunified: "bg-[#D1FAE5] text-[#065F46]",
  closed: "bg-[#F1F5F9] text-[#475569]",
};

export function TypeBadge({ caseType, label }) {
  const style = STATUS_STYLES[caseType] || "bg-[#F1F5F9] text-[#475569]";
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold ${style}`}>
      {label || (caseType === "missing" ? "Desaparecida" : "Encontrada con vida")}
    </span>
  );
}

export function StatusBadge({ label }) {
  return (
    <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-[#F1F5F9] text-[#475569]">
      {label}
    </span>
  );
}

export function MinorBadge() {
  return (
    <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-[#FEE2E2] text-[#991B1B]">
      <ShieldAlert className="w-3.5 h-3.5" /> Menor protegido
    </span>
  );
}

const RISK_STYLES = {
  low: "bg-[#D1FAE5] text-[#065F46]",
  medium: "bg-[#FEF3C7] text-[#92400E]",
  high: "bg-[#FFEDD5] text-[#9A3412]",
  critical: "bg-[#FEE2E2] text-[#991B1B]",
};
const RISK_LABELS = { low: "Bajo", medium: "Medio", high: "Alto", critical: "Crítico" };

export function RiskBadge({ level }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${RISK_STYLES[level] || "bg-[#F1F5F9] text-[#475569]"}`}>
      Riesgo {RISK_LABELS[level] || level}
    </span>
  );
}
